import { Button, Tooltip } from '@mui/material';
import { actionButtonStyled } from '@/styles/overrides';
import { TYPE_TO_ICON } from './constants';
import { Container } from './styled';
import { ActionButtonProps } from './types';

const ActionButton = ({
  disabled = false,
  iconType = 'edit',
  label,
  renderIcon = true,
  onClick,
  tooltip,
  ...props
}: ActionButtonProps) => {
  const button = (
    <Container id="action-button" onClick={() => !disabled && onClick()}>
      <Button color="primary" disabled={disabled} sx={actionButtonStyled} {...props}>
        {renderIcon && TYPE_TO_ICON[iconType]}
        {label}
      </Button>
    </Container>
  );

  return tooltip ? <Tooltip title={tooltip}>{button}</Tooltip> : button;
};

export default ActionButton;
